import React, { useEffect, useState } from "react";
import {
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  useRedirect,
  useRefresh,
  useDataProvider,
  CreateProps,
} from "react-admin";
import { AcademicYearResources, GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import moment from "moment";
import CustomEndDateInput from "components/CustomEndDateInput";
import CreateWrapper from "../../components/CreateWrapper";

const AcademicTermCreate = (props: CreateProps) => {
  const [academicTerms, setAcademicTerms] = useState<IAcademicTerm[]>([]);
  const provider = useDataProvider();
  const param = GetParam();
  const redirect = useRedirect();
  const refresh = useRefresh();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    {
      title: "Academic Years",
      link: `/schools/${param.get("schoolId")}/show/4`,
    },
    {
      title: "Academic Terms",
      link: `/academicYears/${param.get("academicYearId")}/show/1`,
      params: `?schoolId=${param.get("schoolId")}`,
    },
    { title: "Create", link: "" },
  ];

  const CustomRedirect = (props: { data: IAcademicTerm }) => {
    redirect(
      `/academicYears/${props.data.academicYearId}/show/1?schoolId=${param.get(
        "schoolId"
      )}`
    );
    refresh();
  };

  const academicYearResources = AcademicYearResources(
    Number(param.get("academicYearId"))
  );

  useEffect(() => {
    provider
      .getList("academicTerms", {
        filter: { AcademicYearId: Number(param.get("academicYearId")) },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Id",
          order: "ASC",
        },
      })
      .then(({ data }) => {
        setAcademicTerms(data as IAcademicTerm[]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let excludeDates: IExcludeDates[] = [];
  academicTerms.forEach((academicTerm: IAcademicTerm) => {
    let temp: IExcludeDates = {
      startDate: academicTerm.startDate,
      endDate: academicTerm.endDate,
    };

    excludeDates.push(temp);
  });

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New Regular Academic Term"
        onSuccess={CustomRedirect}
        {...props}
      >
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Academic Year</Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select Academic Year"
                source="academicYearId"
                reference="academicYears"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <CustomEndDateInput
                label="Start Date"
                source="startDate"
                parentStartDate={moment
                  .utc(academicYearResources?.startDate)
                  .format("yyyy-MM-DD")}
                parentEndDate={moment
                  .utc(academicYearResources?.endDate)
                  .format("yyyy-MM-DD")}
                excludeDates={excludeDates}
              />
            </Grid>
            <Grid item xs={4}>
              <CustomEndDateInput
                label="End Date"
                source="endDate"
                parentEndDate={moment
                  .utc(academicYearResources?.endDate)
                  .format("yyyy-MM-DD")}
                comparison="startDate"
                excludeDates={excludeDates}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default AcademicTermCreate;
